/** Unisce classi ignorando i valori falsy. */
export function cx(...classi: Array<string | false | null | undefined>): string {
  return classi.filter(Boolean).join(' ');
}
